import TarifasLuz from "../components/views/tarifas-luz.vue";

export default {
  es: {
    hero: {
      title1: "Tarifas",
      title2: "Hogar",
      title3: "Empresas",
    },
    intro: {
      title: "Te presentamos las tarifas de luz de Iner Energía",
      description:
        "Ofrecemos una energía transparente y adaptada a tu forma de consumo. La luz clara y cercana de siempre, ahora con más opciones para ti.",
      tipoTarifa: {
        title: "Tu tarifa <strong>Luz</strong>",
      },
      precioCoste: "Precio coste",
      cuotaFija: "Cuota fija mensual",
      tituloImagen: "Luz a precio<br>de un helado",
    },
    introEmpresas: {
      title:
        "Te presentamos las tarifas de LUZ <br>de Iner Energía para empresas",
      description:
        "Ofrecemos una energía transparente y adaptada a tu forma de consumo. La luz clara y cercana de siempre, ahora con más opciones para ti.",
      tipoTarifa: {
        title: "Tu tarifa <strong>Luz</strong>",
      },
      precioCoste: "Precio coste",
      cuotaFija: "Cuota fija mensual",
    },
    selector: {
      title: "Elige la tarifa que mejor te vaya...",
      subtitle: "¿Cómo es tu consumo?",
      subtitleEmpresas: "¿Cómo es tu empresa?",
      items: {
        hogar: {
          estandar: {
            title: "Estándar",
            description: "Las mejores tarifas <br>para tu hogar",
          },
          solar: {
            title: "Solar",
            description: "Si tienes una instalación <br> fotovoltaica",
          },
          coche_electrico: {
            title: "Coche Eléctrico",
            description: "Si quieres cargar tu coche <br> durante la noche",
          },
        },
        empresas: {
          menos: {
            title: "- de 15 KW",
            description:
              "Autónomos, microempresas, pequeñas y medianas empresas",
          },
          mas: {
            title: "+ de 15 KW",
            description: "Fábricas y grandes empresas",
          },
        },
      },
    },
    tarifas: {
      hogar: {
        estandar: {
          tranquilidad: {
            id: "tranquilidad",
            btn: "TRANQUILIDAD",
            title: "Tarifa 2.0 TD",
            subtitle: '"TRANQUILIDAD"',
            claim: "Esta es perfecta porque…",
            objetive1: "Sin permanencia",
          },
          clasica: {
            id: "clasica",
            btn: "LA CLÁSICA",
            title: "Tarifa 2.0 TD",
            subtitle: '"LA CLÁSICA"',
            claim: "Esta es perfecta para ti si…",
            claim1:
              '¡TARIFA 2.0 "LA CLÁSICA" es tu tarifa! Ahora elige entre...',
            objetive1: "Entre semana pasas poco tiempo en casa.",
            objetive2:
              "Principalmente utilizas los electrodomésticos entre las 22 y las 12 o los fines de semana.",
            objetive3:
              "Te preocupa la eficiencia y el consumo energético responsable.",
            objetive4: "Sin permanencia.",
          },
          precioCoste: {
            id: "precioCoste",
            btn: "A PRECIO DE COSTE",
            title: "Tarifa 2.0 TD",
            subtitle: '"A PRECIO DE COSTE"',
            claim: "Esta es perfecta porque…",
            objetive1: "Disfrutas del precio real de la energía del mercado.",
            objetive2:
              "Pensada para quienes prefieren flexibilidad frente a tarifas cerradas.",
          },
        },
        solar: {
          "2.0Solar": {
            title: "Tarifa 2.0 TD",
            subtitle: '"SOLAR"',
            claim: "Esta es perfecta para ti si…",
            claim1: '¡TARIFA 2.0 "SOLAR" es tu tarifa! Ahora elige entre...',
            objetive1: "Si tienes una instalación fotovoltaica en casa.",
            objetive2:
              "Te preocupa la eficiencia y el consumo energético responsable.",
            objetive4: "Sin permanencia.",
          },
        },
        coche_electrico: {
          CEprecioFijo: {
            id: "CEprecioFijo",
            btn: "A PRECIO FIJO",
            title: "Tarifa 2.0 TD",
            subtitle: '"A PRECIO FIJO"',
            claim: "Esta es perfecta para ti si…",
            claim1:
              '¡TARIFA 2.0 "COCHE ELÉCTRICO" es tu tarifa! Ahora elige entre...',
            objetive1:
              "Quieres cargar tu coche eléctrico durante la noche y aprovechar las horas con precio reducido.",
            objetive2:
              "Buscas una tarifa especial diseñada para el consumo de vehículos eléctricos que te ayude a ahorrar.",
          },
          CEprecioCoste: {
            id: "CEprecioCoste",
            btn: "A PRECIO DE COSTE",
            title: "Tarifa 2.0 TD",
            subtitle: '"A PRECIO DE COSTE"',
            claim: "Esta es perfecta porque…",
            objetive1:
              "Quieres cargar tu coche eléctrico durante la noche y aprovechar las horas con precio reducido.",
            objetive2:
              "Buscas una tarifa especial diseñada para el consumo de vehículos eléctricos que te ayude a ahorrar.",
          },
        },
      },
      empresas: {
        menos: {
          claim1Responsive:
            "Esta es la potencia que tienen la mayoría de las viviendas. Así que seguramente estas tarifas sean para ti.",
          clasica: {
            title: "Tarifa 2.0 TD",
            subtitle: '"LA CLÁSICA"',
            claim: "Esta es perfecta para",

            objetive1: "Cafeterías, pequeños negocios y autónomos.",
            objetive2: "Si abren muy temprano o se trabaja por la noche.",
            objetive3:
              "Si necesitas equipos, como cámaras frigorífcas todo el día.",
          },
          tranquilidad: {
            title: "Tarifa 2.0 TD",
            subtitle: '"TRANQUILIDAD"',
            claim: "Esta es perfecta para ti si…",
            objetive1: "Oficinas pequeñas, autónomos o tiendas pequeñas.",
            objetive2: "El horario de trabajo es durante el día.",
            objetive3:
              "Comercios medianos, oficinas de profesionales de tamaño medio con aire acondicionado o talleres.",
          },
        },
        mas: {
          "empresa3.0": {
            claim1Responsive:
              "Si tu casa, piso, chalet es excepcional, ya sea por su gran tamaño o alguna otra cualidad que la hace poco corriente. Estas serán tus tarifas.",
            title: "Tarifa 3.0 TD",
            subtitle: '"EMPRESA 3.0',
            claim: "Esta es perfecta para ti si…",
            claim1:
              '¡Tarifa 3.0 "EMPRESAS 3.0" es tu tarifa! Ahora elige entre...',
            objetive1:
              "Bares o restaurantes grandes, espacios para eventos, grandes comercios, etc",
          },
          "granEmpresa6.1": {
            title: "Tarifa 6.1",
            subtitle: '"GRAN EMPRESA 6.1"',
            claim: "Esta es perfecta para",
            claim1:
              '¡Tarifa 6.1 "GRAN EMPRESA 6.1" es tu tarifa! Ahora elige entre...',
            objetive1: "Fábricas y fincas agrícolas de regadío.",
            objetive2:
              "En general cualquier negocio que tenga un transformador propio.",
          },
        },
        all: {
          "3.0precioCoste": {
            id: "3.0precioCoste",
            btn: "Empresa 3.0 <br> a precio de coste",
            title: "Tarifa 3.0 TD",
            subtitle: "EMPRESA 3.0 A PRECIO DE COSTE",
            claim: "Esta es perfecta para…",
            objetive1:
              "Bares o restaurantes grandes, espacios para eventos, grandes comercios, etc...",
          },
          "3.0precioFijo": {
            id: "3.0precioFijo",
            btn: "Empresa 3.0 <br> a precio fijo",
            title: "Tarifa 3.0 TD",
            subtitle: "EMPRESA 3.0 A PRECIO FIJO",
            claim: "Esta es perfecta para…",
            objetive1:
              "Bares o restaurantes grandes, espacios para eventos, grandes comercios, etc...",
          },
          "6.1precioCoste": {
            id: "6.1precioCoste",
            btn: "Gran empresa 6.1 <br> a precio de coste",
            title: "Tarifa 6.1",
            subtitle: "GRAN EMPRESA 6.1 A PRECIO DE COSTE",
            claim: "Esta es perfecta para...",
            objetive1: "Fábricas y fincas agrícolas de regadío.",
            objetive2:
              "En general cualquier negocio que tenga un transpormador propio.",
          },
          "6.1precioFijo": {
            id: "6.1precioFijo",
            btn: "Gran empresa 6.1 <br> a precio fijo",
            title: "Tarifa 6.1",
            subtitle: "GRAN EMPRESA 6.1 A PRECIO FIJO",
            claim: "Esta es perfecta para...",
            objetive1: "Fábricas y fincas agrícolas de regadío.",
            objetive2:
              "En general cualquier negocio que tenga un transpormador propio.",
          },
        },
      },
    },
    bannerAyuda: {
      title: "¿Necesitas",
      subtitle: "ayuda?",
      description:
        "Si quieres que uno de nuestros asesores te realice un estudio personalizado ponte en contacto con nosotros y estudiaremos tu caso para ver qué es lo mejor para tu negocio.",
      button: "¿Te ayudamos?",
    },
  },
};  


// WEBPACK FOOTER //
// ./src/translations/tarifas-luz.js